<template>
  <div class="wrapper">
    <input :type="currentType"
           v-model="value"
           class="form-control"
           :disabled="disabled"
           :required="required"
           autocomplete="off"
    >
    <div class="input-group-addon">
      <a @click="unmask" v-if="pwdMasked" href="">
        <i class="fa fa-eye-slash" aria-hidden="true"></i>
        <font-awesome-icon icon="eye-slash"/>
      </a>
      <a @click="mask" v-if="!pwdMasked" href="">
        <i class="fa fa-eye" :aria-hidden="true"></i>
        <font-awesome-icon icon="eye"/>
      </a>
    </div>
  </div>
</template>

<script>
    import {abstractField} from 'vue-form-generator'

    export default {
        name: 'Password',
        mixins: [abstractField],
        methods: {
            unmask(event) {
                event.preventDefault();
                this.pwdMasked = false;
            },
            mask(event) {
                event.preventDefault();
                this.pwdMasked = true;
            }
        },
        computed: {
            currentType() {
                return this.pwdMasked ? 'password' : 'text';
            },
            required() {
                return this.schema.required === undefined ? false : this.schema.required
            }
        },
        data() {
            return {
                pwdMasked: true
            }
        }

    }
</script>

<style lang="scss">
  .field-password {
    a {
      color: inherit;
    }
    input.form-control {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .input-group-addon {
      padding: .5rem .75rem;
      margin-bottom: 0;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.25;
      color: #495057;
      text-align: center;
      background-color: #e9ecef;
      border: 1px solid rgba(0,0,0,.15);
      border-radius: .25rem;
      border-left: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      i {
        color: black;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/core/Form/Fields/Password.vue